<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0;border:0" >
                <FormTitle :titleText="$t('Career_Development')"/><!-- 职业发展 -->
                <div slot="content" style="margin-top: 40px;">
                    <Form :label-width="220" label-position="left">
                        <Row :gutter="100">
                            <!--<Col :xs="24" :sm="24" :md="12" :lg="12">-->
                               <!-- <FormItem :label="$t('Whether_have_STI_or_not')"> 是否享有STI -->
                                    <!-- <Input v-model="formItem.perresult" disabled /> -->
                                    <!-- <Select v-model="formItem.perresult" disabled>
                                        <Option v-for="item in YesOrNo" :value="item.ch_value" :key="item.code" >{{ item.ch_value }}</Option>
                                    </Select> -->
                                <!-- </FormItem>
                            </Col> -->
                            <!--<Col :xs="24" :sm="24" :md="12" :lg="12">
                                <FormItem :label="$t('Carlsberg_Band')"> 嘉士伯级别 -->
                                    <!-- <DatePicker type="date" v-model="formItem.meetingDate" style="width:100%"></DatePicker> 
                                    <Input v-model="formItem.hrgrade" disabled/>
                                </FormItem>
                            </Col> -->
                            <Col :xs="24" :sm="24" :md="12" :lg="12">
                                <FormItem :label="$t('Management_Level')"><!-- 管理层级 -->
                                    <Input v-model="formItem.hrmanage" disabled/>
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12">
                                <FormItem :label="$t('Career_Aspirations')"><!-- 职业理想 -->
                                    <Input v-model="formItem.careerIdeal" :disabled="id!=''"/>
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12">
                                <FormItem :label="$t('Mobility_Location')"><!-- 能动性（地域） -->
                                    <Select v-model="formItem.crossRegion" transfer :disabled="id!=''" clearable >
                                        <Option v-for="item in CrossRegional" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="isRefreash">
                                <FormItem :label="$t('Mobility_Cross-Team_or_Cross-Function')"><!-- 能动性（跨团队跨职能） -->
                                    <Select  v-model="formItem.crossFun" transfer multiple clearable :disabled="id!=''">
                                        <Option v-for="item in ChinaGroupType" :value="item.code" :key="item.code" >{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id!=''">
                                <FormItem :label="$t('Target_Position')"><!-- 目标发展岗位 -->
                                    <Input v-model="formItem.targetPosition" />
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id!=''">
                                <FormItem :label="$t('Readiness_for_Next_Position')"><!-- 下一岗位的准备度 -->
                                    <Select v-model="formItem.nextJob" clearable>
                                        <Option v-for="item in NextJob" :value="item.code" :key="item.code" >{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id!=''">
                                <FormItem :label="$t('Releasibility_')"><!-- 业务可释放的时间 -->
                                    <!-- <DatePicker v-model="formItem.releaseDate" style="width:100%" transfer type="date" ></DatePicker> -->
                                    <Select v-model="formItem.releaseDate" clearable transfer>
                                        <Option v-for="item in ServiceRelease" :value="item.code" :key="item.code" >{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id!=''">
                                <FormItem :label="$t('Attrition_Risk')"><!-- 离职风险 -->
                                    <Select v-model="formItem.exitRisk" transfer clearable>
                                        <Option v-for="item in ExitRisk" :value="item.code" :key="item.code" >{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <!--<Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id!=''">
                                <FormItem :label="$t('Impact_of_Attrition')"> 离职影响 
                                    <Input v-model="formItem.exitAffect" />
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id!=''">
                                <FormItem :label="$t('放入哪个人才库')"> 放入哪个人才库 
                                    <Select v-model="formItem.talentPool" transfer clearable  multiple>
                                        <Option v-for="item in postFun" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>-->
                            <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id!=''">
                                <FormItem :label="$t('Talent_Transfer_Plan')">  
                                    <Select v-model="formItem.talentTransferPlan"  clearable  >
                                        <Option v-for="item in talentTransferPlan" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col :xs="24" :sm="24" :md="12" :lg="12" v-if="id!=''">
                                <FormItem :label="$t('Resignation_impact')">  
                                        <Select v-model="formItem.exitImpact"  clearable  >
                                            <Option v-for="item in exitImpact" :value="item.code" :key="item.code">{{lang=="zh"?item.ch_value:item.en_value}}</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                        </Row>
                    </Form>
                </div>
            </Panel>
        </Collapse>
        <div  v-if="id==''">
            <span style="color: red;">{{$t('EmpFilesCareer')}}</span>
        </div> 
        <div  v-if="id!=''">
            <span style="color: red;">{{$t('EmpFilesCareerManager')}}</span>
        </div> 
        <Spin size="large" fix v-if="spinShow"></Spin>
        <Divider />

        <div class="btnfooter" >
            <Button type="primary" class="btn" @click="save" ><!-- 保存 -->{{$t('Save')}}</Button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            date: new DateUtil(),
            isRefreash:true,
            formItem:{},
            list:[],
            value:[1],
            id:'',
            serialnumber:'',
            YesOrNo:[],
            NextJob:[],
            ExitRisk:[],
            CrossRegional:[],
            ChinaGroupType:[],
            ServiceRelease:[],
            postFun:[],
            talentTransferPlan:[],
            exitImpact:[],
            spinShow:false
        }
    },
    watch:{
     "lang"(val){
         this.isRefreash=false;
         this.$nextTick(()=>{
            this.isRefreash=true;
         })
     }
    },
    computed:{
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    methods:{
        getData(val){
            this.spinShow=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/careerDevelopment/selectUserCareerDevelopmentData", {serialnumber:this.serialnumber}).then((res) => {
                this.spinShow=false
                if (res) {
                   this.formItem=res.data[0];
                   this.formItem.talentPoolFiled = "";
                   this.YesOrNo=res.optionData.YesOrNo
                   this.NextJob=res.optionData.NextJob
                   this.ExitRisk=res.optionData.ExitRisk
                   this.CrossRegional=res.optionData.CrossRegional
                   this.ServiceRelease=res.optionData.ServiceRelease
                   this.postFun = res.optionData.postFun
                   this.ChinaGroupType = res.optionData.ChinaGroupType
                   this.talentTransferPlan = res.optionData.talentTransferPlan
                   this.exitImpact = res.optionData.exitImpact
                }
            })
        },
        save(){
            
            axios.post("/careerDevelopment/updateUserCareerDevelopmentData",this.formItem).then((res) => {
                if (res) {
                    this.$Message.success(this.$t('Save_Successful'))
                    this.getData(this.serialnumber)
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/CareerDevelopment.vue